import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=2e87b392&scoped=true&"
import script from "./myInvoice.vue?vue&type=script&lang=js&"
export * from "./myInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87b392",
  null
  
)

export default component.exports